export function metaJsonLd(pageName) {
	console.log('meta-json-ld.js / ' + pageName);
	/**
	 * OGP オープン・グラフ・プロトコル
	 * <meta property="og:title" content="タイトル">
	 * <meta property="og:description" content="ページの概要">
	 * <meta property="og:type" content="ページタイプ">
	 * <meta property="og:url" content="ページのURL">
	 * <meta property="og:image" content="アイキャッチ">
	 * <meta property="og:site_name" content="サイト名">
	 * <meta property="og:locale" content="ja_JP">
	 * <meta name="twitter:card" content="カードの種類（summaryまたはsummary_large_image）">
	 * <meta name="twitter:site" content="Twitterアカウント名（@を含む）">
	 */
	
	let title       = '',
		title1      = '',
		description = '';
	
	switch (pageName) {
		case 'Greeting':
			title       = '理事長挨拶';
			title1      = '史上最高の自分になるメソッド';
			description = '由数学とは、新しいコミュニケーションツールを提供するプロファイリングメソッドです。このプロファイリングメソッドは、創設者の25年による実業実績と、統計学・分類学などの学問を融合させたオリジナルメソッドです。「風の時代」と言われる今、個を大切にし、互いを理解し合えるメソッド。それが由数学なのです。';
			break;
		case 'EntryPreSeminar':
			title       = '体験セミナー申込み';
			title1      = '史上最高の自分になるメソッド';
			description = '由数学とは、新しいコミュニケーションツールを提供するプロファイリングメソッドです。このプロファイリングメソッドは、創設者の25年による実業実績と、統計学・分類学などの学問を融合させたオリジナルメソッドです。「風の時代」と言われる今、個を大切にし、互いを理解し合えるメソッド。それが由数学なのです。';
			break;
		case 'BranchIntroduction':
			title       = '全国支部校紹介';
			title1      = '史上最高の自分になるメソッド';
			description = '由数学とは、新しいコミュニケーションツールを提供するプロファイリングメソッドです。このプロファイリングメソッドは、創設者の25年による実業実績と、統計学・分類学などの学問を融合させたオリジナルメソッドです。「風の時代」と言われる今、個を大切にし、互いを理解し合えるメソッド。それが由数学なのです。';
			break;
		case 'Contact':
			title       = 'お問い合わせ';
			title1      = '史上最高の自分になるメソッド';
			description = '由数学とは、新しいコミュニケーションツールを提供するプロファイリングメソッドです。このプロファイリングメソッドは、創設者の25年による実業実績と、統計学・分類学などの学問を融合させたオリジナルメソッドです。「風の時代」と言われる今、個を大切にし、互いを理解し合えるメソッド。それが由数学なのです。';
			break;
		case 'SignIn':
			title       = 'サインイン';
			title1      = '史上最高の自分になるメソッド';
			description = '由数学とは、新しいコミュニケーションツールを提供するプロファイリングメソッドです。このプロファイリングメソッドは、創設者の25年による実業実績と、統計学・分類学などの学問を融合させたオリジナルメソッドです。「風の時代」と言われる今、個を大切にし、互いを理解し合えるメソッド。それが由数学なのです。';
			break;
		case 'Home':
		default:
			title       = '史上最高の自分になるメソッド';
			description = '由数学とは、新しいコミュニケーションツールを提供するプロファイリングメソッドです。このプロファイリングメソッドは、創設者の25年による実業実績と、統計学・分類学などの学問を融合させたオリジナルメソッドです。「風の時代」と言われる今、個を大切にし、互いを理解し合えるメソッド。それが由数学なのです。';
			break;
		
	}
	
	switch (pageName) {
		case 'Home' :
			return {
				title: title,
				titleTemplate: '%s|由数学協会',
				meta: [
					{name: 'description', content: description},
					{property: 'og:title', content: title},
					{property: 'og:description', content: description},
					{property: 'og:locale', content: 'ja_JP'},
					// TOPページの場合は「website」、WEBサイト上の記事ページなど、TOPページ以外には「article」
					{property: 'og:type', content: 'website'},
					{property: 'og:url', content: location.href},
					{property: 'og:site_name', content: document.title},
					// Facebookでは画像サイズを1200×630p、比率で「1.91：1」を推奨しています。
					{
						property: 'og:image',
						content: DIR + '/src/assets/img/yusuugaku-logo-gold.svg',
					},
					/* TWITTER */
					{name: 'description', content: description},
					{property: 'twitter:card', content: 'summary'},
					{property: 'twitter:title', content: document.title},
					{property: 'twitter:description', content: description},
					//
					{
						property: 'twitter:image',
						content: DIR + '/src/assets/img/yusuugaku-logo-gold.svg',
					},
				],
				script: [
					{
						type: 'application/ld+json',
						innerHTML: JSON.stringify(
							{
								"@context": "https://schema.org",
								"@graph": [
									{
										"@type": "WebSite",
										"headline": document.title,
										"description": description,
										"inLanguage": "ja",
										"mainEntityOfPage": {
											"@type": "WebPage",
											"@id": HOME_URL,
										},
										"image": {
											"@type": "ImageObject",
											"url": DIR + "/src/assets/img/yusuugaku-logo-gold.svg"
										},
										"publisher": {
											"@type": "Organization",
											"name": "由数学協会",
											"logo": {
												"@type": "ImageObject",
												"url": DIR + "/src/assets/img/yusuugaku-logo-gold.svg"
											}
										}
									},
									{
										"@type": "LocalBusiness",
										"@id": HOME_URL,
										"name": "由数学協会",
										"url": HOME_URL
									},
									{
										"@type": "BreadcrumbList",
										"@id": location.href,
										"itemListElement": [
											{
												"@type": "ListItem",
												"position": 1,
												"item": {
													"@id": HOME_URL,
													"name": 'HOME',
												}
											}
										]
									},
								]
							}, null, 2,
						),
					}
				]
			};
		
		
		default:
			return {
				title: title,
				titleTemplate: '%s|由数学協会',
				meta: [
					{name: 'description', content: description},
					{property: 'og:title', content: title},
					{property: 'og:description', content: description},
					{property: 'og:locale', content: 'ja_JP'},
					// TOPページの場合は「website」、WEBサイト上の記事ページなど、TOPページ以外には「article」
					{property: 'og:type', content: 'article'},
					{property: 'og:url', content: location.href},
					{property: 'og:site_name', content: document.title},
					// Facebookでは画像サイズを1200×630p、比率で「1.91：1」を推奨しています。
					{
						property: 'og:image',
						content: DIR + '/src/assets/img/yusuugaku-logo-gold.svg',
					},
					/* TWITTER */
					{name: 'description', content: description},
					{property: 'twitter:card', content: 'summary'},
					{property: 'twitter:title', content: document.title},
					{property: 'twitter:description', content: description},
					//
					{
						property: 'twitter:image',
						content: DIR + '/src/assets/img/yusuugaku-logo-gold.svg',
					},
				],
				script: [
					{
						type: 'application/ld+json',
						innerHTML: JSON.stringify(
							{
								"@context": "https://schema.org",
								"@graph": [
									{
										"@type": "WebSite",
										"headline": document.title,
										"description": description,
										"inLanguage": "ja",
										"mainEntityOfPage": {
											"@type": "WebPage",
											"@id": HOME_URL,
										},
										"image": {
											"@type": "ImageObject",
											"url": DIR + "/src/assets/img/yusuugaku-logo-gold.svg"
										},
										"publisher": {
											"@type": "Organization",
											"name": "由数学協会",
											"logo": {
												"@type": "ImageObject",
												"url": DIR + "/src/assets/img/yusuugaku-logo-gold.svg"
											}
										}
									},
									{
										"@type": "LocalBusiness",
										"url": HOME_URL,
										"name": "由数学協会",
										"logo": DIR + "/src/assets/img/yusuugaku-logo-gold.svg"
									},
									{
										"@type": "BreadcrumbList",
										"@id": location.href,
										"itemListElement": [
											{
												"@type": "ListItem",
												"position": title1,
												"item": {
													"@id": HOME_URL,
													"name": 'HOME',
												}
											},
											{
												"@type": "ListItem",
												"position": 2,
												"item": {
													"@id": location.href,
													"name": title,
												}
											}
										]
									},
								]
							}, null, 2,
						),
					}
				]
			};
	}
}